import React, { useEffect, useState } from 'react'
import { Box, Grid, Link, TextField, BottomNavigationAction, FormControlLabel, Switch } from '@material-ui/core';
import { Field } from 'formik';
import { useStore } from '../../Store'
import Header from '../Header'
import ActionBar from '../ActionBar';
import SaveIcon from '@material-ui/icons/Save';
import Location from '../Location';
import Photos from '../Photos';
import VisitService from '../../services/VisitService';
import DatePicker from '../DatePicker';
import moment from 'moment';
import { getErrorProps, getOptions } from '../../utils';
import { Filter } from '@material-ui/icons';

const ObservationDetails = ({ readonly, formik, handleCancel, handleSubmit, single }) => {
    const { plots, settings } = useStore()
    const [siblings, setSiblings] = useState([])
    const [showAll, setShowAll]= useState(false)

    const plotId= formik.values.plot||-1
    const obsId= formik.values.observation?formik.values.observation.id:0
    const dateStart= moment(formik.values.dateStart)
    const seasonStart= moment(`${dateStart.month()<3?dateStart.year()-1:dateStart.year()}-04-01`)
    const seasonStop= moment(`${dateStart.month()>=3?dateStart.year()+1:dateStart.year()}-03-31`)

    useEffect(() => {
        if (plotId !== -1) {
            VisitService.getSiblings(plotId)
            .then(response => {
                setSiblings(response.data.filter(o => o.id !== obsId))
            })
        }
    }, [plotId, obsId])

    const filteredSiblings= () => {
        //console.log(seasonStart, seasonStop)
        const filtered= siblings.filter(o => {
            return showAll || moment(o.timeStart).isBetween(seasonStart,seasonStop)
        })
        return filtered
    }

    const datestart = `observation.dateStart`
    const description = `observation.description`
    const opm_waarneming = `observation.extraInfo.opmerking_wrn`
    const location = `observation.location`
    const volgnummer = `observation.extraInfo.volgnummer`
    const onderwerp = `observation.extraInfo.onderwerp`
    const locatietype = `observation.extraInfo.locatietype`
    const locatietype_opm = `observation.extraInfo.locatietype_opm`
    const zoekmethode = `observation.extraInfo.zoekmethode`


    const getPlot = () => {
        const plot = plots.find(p => p.id === formik.values.plot)
        return plot
    }

    const updateDescription = (value) => {
        const newval = (value && value.isValid() ? value.format('DD-MM-YYYY') : '')
        formik.setFieldValue(description, newval)
    }

    const handleSelect = (obs) => { 
        formik.setFieldValue(location, obs.location)
        formik.setFieldValue(locatietype, obs.extraInfo.locatietype||'')
        formik.setFieldValue(onderwerp, obs.extraInfo.onderwerp||'')
        formik.setFieldValue(zoekmethode, obs.extraInfo.zoekmethode||'')
        formik.setFieldValue(locatietype_opm, obs.extraInfo.locatietype_opm||'')
    }

    return (
        formik.values.observation &&
        <>
            <Header title={formik.values.observation.description || 'Nieuwe waarneming'} backAction={handleCancel} />
            <Box m={2}>
                <Grid container>
                    {single && 
                        <Grid item xs={12} >
                            <Field disabled={readonly} label="datum" variant="standard" name={datestart} fullWidth {...getErrorProps(formik, datestart)} component={DatePicker}
                                onChange={updateDescription} />
                        </Grid>}
                    <Grid item xs={12}>
                        <Field id={formik.values.observation.id} disabled={readonly} readonly={readonly} plot={getPlot()} observations={filteredSiblings()} onSelect={handleSelect} label="location" variant="standard" name={location} errorProps={(name)=>getErrorProps(formik, name)} {...formik.getFieldProps(location)} component={Location} />
                    </Grid>
                    {!single &&
                        <Grid item xs={12}>
                            <TextField disabled={true} label="volgnummer" variant="standard" name={volgnummer} fullWidth {...getErrorProps(formik, volgnummer)} {...formik.getFieldProps(volgnummer)} />
                        </Grid>}
                        {!single &&
                        <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={showAll}
                                onChange={e => setShowAll(e.target.checked)}
                                name="checkedB"
                                color="primary"
                                disabled={readonly}
                            />
                        }
                        label="toon alle waarnemingen" />
                </Grid>}

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="locatietype" variant="standard" name={locatietype} fullWidth  {...getErrorProps(formik, locatietype)} {...formik.getFieldProps(locatietype)} >
                            {getOptions(settings.lists["locatietype"])}
                        </TextField>
                    </Grid>

                    {formik.values.observation.extraInfo.locatietype === 'anders' &&
                        <Grid item xs={12}>
                            <TextField disabled={readonly} label="ander locatietype" variant="standard" name={locatietype_opm} fullWidth  {...getErrorProps(formik, locatietype_opm)} {...formik.getFieldProps(locatietype_opm)} />
                        </Grid>
                    }

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="wat gevonden?" variant="standard" name={onderwerp} fullWidth  {...getErrorProps(formik, onderwerp)} {...formik.getFieldProps(onderwerp)} >
                            {getOptions(settings.lists["onderwerp"])}
                        </TextField>
                    </Grid>

                    {formik.values.observation.extraInfo.onderwerp === 'levend' &&
                        <Grid item xs={12}>
                            <TextField select disabled={readonly} label="hoe waargenomen" variant="standard" name={zoekmethode} fullWidth  {...getErrorProps(formik, zoekmethode)} {...formik.getFieldProps(zoekmethode)} >
                                {getOptions(settings.lists["zoekmethode"])}
                            </TextField>
                        </Grid>
                    }

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="opmerkingen" variant="standard" name={opm_waarneming} multiline fullWidth  {...getErrorProps(formik, opm_waarneming)} {...formik.getFieldProps(opm_waarneming)} />
                    </Grid>

                    <Grid item xs={12}>
                        <Photos
                            uploads={formik.values.observation.uploads}
                            setUploads={(uploads) => formik.setFieldValue('observation.uploads', uploads)}
                            readonly={readonly}
                            formik={formik}
                        />
                    </Grid>

                </Grid>
            </Box>
            {!readonly &&
                <ActionBar>
                    {!readonly && <BottomNavigationAction label="Waarneming opslaan" component={Link} to="/" onClick={handleSubmit} style={{ color: '#00547d' }} icon={<SaveIcon />} />}
                </ActionBar>
            }
        </>

    )
}

export default ObservationDetails
